import { useTranslation } from "react-i18next";
import React from "react";

interface PaymentInfoProps {
  guests: { price: number; guestNumber: number; type: string }[];
  additionalFee: number;
  vatServiceCharge: number;
  payAmount: number;
}

const PaymentInfo: React.FC<PaymentInfoProps> = ({
  guests,
  additionalFee,
  vatServiceCharge,
  payAmount,
}) => {
  const { t } = useTranslation();
  return (
    <div className="} rounded-[1.25rem] border border-[#DCDCDC] p-[1.25rem] pr-[6.25rem] pt-[1.3125rem]">
      <div className="">
        <div className="flex flex-col gap-[0.9375rem]">
          <p className="text-base font-semibold">{t("Payment information")}</p>

          <div className="flex justify-start">
            <p className="flex w-[22rem] text-[0.875rem] font-semibold">
              {t("Price")}
            </p>
            <div className="flex w-[29.5625rem] items-center justify-between text-[0.875rem]">
              <p className="font-normal text-[#232323]">
                {guests
                  .map((g) => `$${g.price} x ${g.guestNumber} ${g.type}`)
                  .join(", ")}
              </p>
            </div>
          </div>

          <div className="flex justify-start">
            <p className="flex w-[22rem] text-[0.875rem] font-semibold">
              {t("Additional fee")}
            </p>
            <div className="flex w-[29.5625rem] items-center justify-between">
              <p className="text-[0.875rem] font-normal text-[#232323]">
                +${additionalFee}
              </p>
            </div>
          </div>

          <div className="flex justify-start">
            <p className="flex w-[22rem] text-[0.875rem] font-semibold">
              {t("VAT & Service charge")}
            </p>
            <div className="flex w-[29.5625rem] items-center justify-between">
              <p className="text-[0.875rem] font-normal text-[#232323]">
                {vatServiceCharge}
              </p>
            </div>
          </div>

          <div className="flex justify-start">
            <p className="flex w-[22rem] text-[0.875rem] font-semibold">
              {t("Pay amount")}
            </p>
            <div className="flex w-[29.5625rem] items-center justify-between">
              <p className="text-[0.875rem] font-normal text-[#232323]">
                ${payAmount}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInfo;
